import * as ng from 'angular';
import { ValidFile } from './valid-file.directive';


export const ValidFileModule: string =
    ng.module('valid-file', [
    ])
        .directive('validFile', ValidFile)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/valid-file/valid-file.module.ts